import React from "react";
import MapControl from "components/OverviewPages/Map/MapControl";
import PropTypes from "prop-types";

export default function MapWithCustomMarkers({
  markers,
  startingZoom,
  clusterMarkers,
  selectedMarker
}) {
  return (
    <MapControl
      markers={markers}
      clusterMarkers={clusterMarkers}
      centralizeAroundMarkers={true}
      startingZoom={startingZoom}
      selectedMarker={selectedMarker}
    />
  );
}
MapWithCustomMarkers.propTypes = {
  markers: PropTypes.array,
  startingZoom: PropTypes.number,
  clusterMarkers: PropTypes.bool,
  selectedMarker: PropTypes.string
};
MapWithCustomMarkers.defaultProps = {
  markers: [],
  startingZoom: 5,
  clusterMarkers: false
};
